import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import Pokedex from "./pokedex";
import Pokemon from "./pokemon";
import { Paper, Typography } from "@material-ui/core";
import SwitchButton from "@material-ui/core/Switch/Switch";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

function App() {
  const [dark, setDark] = useState(true);
  const HandleDark = () => {
    setDark(!dark);
  };
  const theme = createMuiTheme({
    palette: {
      type: dark ? "dark" : "light",
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <Paper square={true} style={{ minHeight: "100vh" }}>
          Dark Mode:
          <SwitchButton onChange={HandleDark} defaultChecked />{" "}
          <Typography
            align="left"
            component="span"
            style={{ fontSize: "12px" }}
          >
            Developed by: <b>ShAkiR JamiL</b>
          </Typography>
          <Switch>
            <Route exact path="/" render={(props) => <Pokedex {...props} />} />
            <Route
              path="/:pokemonId"
              render={(props) => <Pokemon {...props} />}
            />
          </Switch>
        </Paper>
      </ThemeProvider>
    </>
  );
}

export default App;
